import { PropsWithChildren } from "react";
import { Badge, cn } from "web-design-system";

export function FundCategoryBadge(
  props: PropsWithChildren<{ category: string }>
) {
  return (
    <Badge
      variant="custom"
      className={cn({
        "text-tag-green-foreground bg-tag-green": props.category === "Debt",
        "text-tag-violet-foreground bg-tag-violet": props.category === "Equity",
        "text-tag-blue-foreground bg-tag-blue":
          props.category === "Commodities" || props.category === "Hybrid",
      })}
    >
      {props.children}
    </Badge>
  );
}
